import React from "react";
import DataSelect from "@/components/common/select/DataSelect";
import type { cardTestFilterProps } from "./types.props";

const CardTestFilter: React.FC<cardTestFilterProps> = ({
    options,
    selectedValue,
    className,
    onChange,
}) => {
    if (options.length <= 1) {
        return null;
    }

    return (
        <div className={className}>
            <DataSelect
                id="card-test-filter"
                name="testFilter"
                options={options}
                value={selectedValue}
                onChange={(e) => onChange(e.target.value)}
                variant="header"
            />
        </div>
    );
};

export default CardTestFilter;
